/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Welcome_S1_CapInputs */

const en_funnel_ob_welcome_s1_cap = /** @type {(inputs: Funnel_Ob_Welcome_S1_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste anything. A PDF, article, or link.`)
};

const es_funnel_ob_welcome_s1_cap = /** @type {(inputs: Funnel_Ob_Welcome_S1_CapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega lo que sea: un PDF, un artículo o un enlace.`)
};

/**
* | output |
* | --- |
* | "Paste anything. A PDF, article, or link." |
*
* @param {Funnel_Ob_Welcome_S1_CapInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_welcome_s1_cap = /** @type {((inputs?: Funnel_Ob_Welcome_S1_CapInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Welcome_S1_CapInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_welcome_s1_cap(inputs)
	return en_funnel_ob_welcome_s1_cap(inputs)
});